import { useContext } from 'react'
import { GreetingIsDisplayedType, GreetingIsDisplayedContext } from './GreetingDisplayStatusProvider'

const useGreetingDisplayStatus: () => GreetingIsDisplayedType = () => useContext(GreetingIsDisplayedContext)

export default useGreetingDisplayStatus
